import React from 'react';
import CanvasJSReact from '@canvasjs/react-charts';
import Paper from '@mui/material/Paper';
import { Box, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

import '@components/charts/styles/dashboard-styles.css';

// palette for the slices
const SLICE_COLORS = [
  '#00B894', // green
  '#0984E3', // blue
  '#E17055', // orange
  '#6C5CE7', // violet
  '#FF7675', // red
];

const PieDistribuionEquipament = ({ TITLE, DATA_POINTS, loading = false }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const total = DATA_POINTS?.reduce((sum, p) => sum + (p.y || 0), 0) || 0;

  if (total === 0 && !loading) {
    return (
      <Box width="100%" height="100%">
        <Paper elevation={5} sx={{ p: 2.5, height: '100%', display: 'flex', flexDirection: 'column' }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
            <Typography variant="h6" fontWeight={700} sx={{ color: 'text.primary' }}>
              {TITLE}
            </Typography>
          </Box>
          <Box flex={1} display="flex" alignItems="center" justifyContent="center" minHeight={260}>
            <Typography color="text.secondary">Nenhuma ocorrência registrada.</Typography>
          </Box>
        </Paper>
      </Box>
    );
  }

  const chartOptions = {
    animationEnabled: true,
    backgroundColor: 'transparent',
    theme: isDark ? 'dark2' : 'light2',
    toolTip: {
      shared: true,
      content: '{label}: #percent%',
      backgroundColor: isDark ? '#162328' : '#ffffff',
      fontColor: isDark ? '#f1f5f9' : '#1e293b',
      borderColor: isDark ? 'rgba(255, 255, 255, 0.2)' : '#e2e8f0',
    },
    legend: {
      verticalAlign: 'center',
      horizontalAlign: 'right',
      fontSize: 13,
      fontFamily: 'Mukta, Saira, Roboto, sans-serif',
      fontColor: isDark ? '#f1f5f9' : '#1e293b',
      cursor: 'pointer',
    },
    exportEnabled: false,
    zoomEnabled: false,
    data: [
      {
        type: 'doughnut',
        startAngle: -90,
        innerRadius: '65%',
        indexLabelPlacement: 'inside',
        indexLabel: ' ',
        yValueFormatString: '#,##0.##',
        showInLegend: true,
        legendText: '{label} – #percent%',
        dataPoints: (DATA_POINTS || []).map((p, i) => ({
          ...p,
          color: p.color || SLICE_COLORS[i % SLICE_COLORS.length],
        })),
      },
    ],
  };

  return (
    <Box width="100%" height="100%">
      <Paper
        elevation={5}
        sx={{
          p: 2.5,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <Typography variant="h6" fontWeight={700} sx={{ color: 'text.primary' }}>
            {TITLE}
          </Typography>
        </Box>

        {/* content */}
        <Box
          flex={1}
          display="flex"
          alignItems="center"
          justifyContent="center"
          minHeight={260}
          position="relative"
        >
          {loading ? <CircularProgress /> : <CanvasJSChart options={chartOptions} />}
        </Box>
      </Paper>
    </Box>
  );
};

PieDistribuionEquipament.propTypes = {
  TITLE: PropTypes.string,
  DATA_POINTS: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      y: PropTypes.number,
    })
  ),
  loading: PropTypes.bool,
};

export default PieDistribuionEquipament;
